import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './leyDisciplinaFinanciera.css';

const LeyDisciplinaFinanciera = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);

  return (
    <div className='container'>
        <div className='row'>
            <div className='ldf_titulo'>
                <h2>Ley de Disciplina Financiera</h2>
                <hr className='hr-gob'/>
            </div>

            <table className="table table-striped table-bordered tabla_elementos">
                <tbody>
                    <tr>
                        <td>2018</td>
                        <td>2019</td>
                        <td>2020</td>
                        <td><h3><Link to="DetalleLeyDisciplinaFinanciera/LeyDisciplinaFinanciera2021">2021</Link></h3></td>
                        <td><h3><Link to="DetalleLeyDisciplinaFinanciera/LeyDisciplinaFinanciera2022">2022</Link></h3></td>
                    </tr>
                    <tr>
                        <td><h3><Link to="DetalleLeyDisciplinaFinanciera/LeyDisciplinaFinanciera2023">2023</Link></h3></td>
                        <td><h3><Link to="DetalleLeyDisciplinaFinanciera/LeyDisciplinaFinanciera2024">2024</Link></h3></td>
                        <td><h3><Link to="DetalleLeyDisciplinaFinanciera/LeyDisciplinaFinanciera2025">2025</Link></h3></td>
                        <td><h3><Link to="DetalleLeyDisciplinaFinanciera/LeyDisciplinaFinanciera2026">2026</Link></h3></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                </tbody>
            </table>
         </div>
     </div>
  )
}

export default LeyDisciplinaFinanciera